var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAsterisks = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "#D11F00",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.04 4.36L0.6 3.64L1.24 2.18L3.36 3.28L3.08 0.719999H4.74L4.46 3.28L6.58 2.18L7.2 3.64L4.78 4.36L6.66 6.4L5.36 7.34L3.92 5.14L2.46 7.34L1.16 6.4L3.04 4.36Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAsterisks);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Asterisks.e493e3d7ddcaad66ae48fd614491a470.svg";